import { matchers } from '../http-request';

const INITIAL_STATE = [];

export function ErrorReducer(state = INITIAL_STATE, action) {
  // Handle outgoing requests - clear errors
  if (matchers.core.isRequest(action)) {
    return INITIAL_STATE;

    // Handle incoming request results - set errors
  } else if (matchers.core.isRequestResultError(action)) {
    return [...state, action];
  }

  return state;
}
